import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Box, Divider, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  RHFSwitch,
  RHFTextArea,
  RHFTextField,
} from "../../../../components/hook-form";
import FormProvider from "../../../../components/hook-form/FormProvider";
import { Upload } from "../../../../components/upload";
import {
  createVehicleType,
  updateVehicleType,
} from "../../../../redux/slices/vehicleSlice";
import { appendFormValuesToFormData } from "../../../../utils/appendFormData";

const Form = ({ handleClose, data, isEdit = false }) => {
  // TODO: hooks

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // TODO: useStates
  const [logo, setLogo] = useState(null);

  // TODO: get the data from slice

  const createTypeLoading = useSelector((state) => state.vehicle.isLoading);

  const Schema = Yup.object().shape({
    name: Yup.string().required("name is required"),
    order: Yup.string().required("order is required"),
    capacity: Yup.number()
      .typeError("capacity must be a number")
      .required("capacity is required"),
  });

  // TODO: default values in the form
  const defaultValues = useMemo(
    () => ({
      name: data?.name,
      capacity: data?.capacity,
      description: data?.description,
      logo: data?.logo,
      remarks: data?.remarks,
      order: data?.order,
      status: data?.status ? 1 : 0,
      is_pool_available: data?.is_pool_available ? 1 : 0,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const { handleSubmit } = methods;

  // TODO: useEffects, write the useEffect codes here

  // ======

  // TODO: functions

  const handleDropPhoto = useCallback((acceptedFiles) => {
    const newFile = acceptedFiles[0];
    if (newFile) {
      setLogo(
        Object.assign(newFile, {
          preview: URL.createObjectURL(newFile),
        })
      );
      setLogo(acceptedFiles[0]);
    }
  }, []);

  const onCreateVehicleType = (values) => {
    const formData = new FormData();

    delete values.logo;

    appendFormValuesToFormData(formData, {
      ...values,
      status: values.status ? 1 : 0,
      is_pool_available: values.is_pool_available ? 1 : 0,
    });

    if (logo) {
      formData.append("logo", logo);
    }
    // TODO: dispatch the action to create a vehicle type

    dispatch(
      createVehicleType({ data: formData, enqueueSnackbar, handleClose })
    );
  };

  const onUpdateVehicleType = (values) => {
    const formData = new FormData();

    delete values.logo;

    appendFormValuesToFormData(formData, {
      ...values,
      status: values.status ? 1 : 0,
      is_pool_available: values.is_pool_available ? 1 : 0,
    });

    if (logo) {
      formData.append("logo", logo);
    }

    // TODO: dispatch the action to update a vehicle type
    dispatch(
      updateVehicleType({
        data: formData,
        enqueueSnackbar,
        handleClose,
        id: data?.id,
      })
    );
  };

  // TODO: console.logs

  return (
    <Box p={3}>
      <FormProvider
        methods={methods}
        onSubmit={handleSubmit(
          isEdit ? onUpdateVehicleType : onCreateVehicleType
        )}
      >
        <Stack flexDirection={"row"} justifyContent={"center"} mb={2}></Stack>
        <Box
          rowGap={3}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
          }}
        >
          <RHFTextField name={"name"} label={"Vehicle type's name *"} />
          <RHFTextField name={"order"} label={"Order to diplay *"} />

          <RHFTextField name={"capacity"} label={"Vehicle capacity *"} />
          <RHFTextField name={"remarks"} label={"Remarks"} />
        </Box>

        <Stack mt={3}>
          <Box
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(1, 1fr)",
              sm: "repeat(1, 1fr)",
            }}
          >
            <RHFTextArea name={"description"} label={"Description"} />
          </Box>
        </Stack>

        <Stack mt={3}>
          <Divider />

          <span className="mt-3">Stasuses</span>

          <Box
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
            }}
          >
            <div className="border-2 w-fit p-2 rounded-xl">
              <RHFSwitch
                name={"status"}
                label={<span>Make the vehicel type visible?</span>}
                labelPlacement="start"
              />
            </div>

            <div className="border-2 w-fit p-2 rounded-xl">
              <RHFSwitch
                name={"is_pool_available"}
                label={<span>Is pool available?</span>}
                labelPlacement="start"
              />
            </div>
          </Box>
        </Stack>

        <Stack flexDirection={"row"} justifyContent={"center"} mt={3}>
          <Upload
            isAvatar={false}
            text={"Upload picture"}
            file={logo || defaultValues.logo}
            name="image"
            accept="image/*"
            maxSize={1}
            onDrop={handleDropPhoto}
          />
        </Stack>

        <Stack mt={2} alignItems={"end"}>
          <LoadingButton
            loading={createTypeLoading}
            disabled={createTypeLoading}
            type="submit"
            variant="contained"
            className="!bg-primary w-fit"
          >
            {isEdit ? "Update Vehicle Type" : "Create Vehicle Type"}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Box>
  );
};

export default Form;
